// extracted by mini-css-extract-plugin
module.exports = {"footer":"styles_footer__2aaWh","content":"styles_content__3UqgG","selectAll":"styles_selectAll__1fKc3"};